import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { API_URL } from '../config';
import './DataPage.css';

// ── Style Variables ──────────────────────────────────────────────────────────
const containerStyle = { backgroundColor: '#f5f5f5', minHeight: '100vh' };
const pageHeaderStyle = {
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'flex-start',
  marginBottom: '24px',
  flexWrap: 'wrap',
  gap: '12px',
};
const pageIconStyle = {
  fontSize: '1.5rem',
  lineHeight: 1,
};
const pageTitleStyle = {
  fontSize: '1.5rem',
  fontWeight: '700',
  color: '#1a1a2e',
  margin: '0 0 2px 0',
};
const pageSubtitleStyle = {
  fontSize: '0.85rem',
  color: '#666',
  margin: 0,
};
const cardStyle = { backgroundColor: '#fff', borderRadius: '8px', boxShadow: '0 1px 3px rgba(0,0,0,0.1)', padding: '24px', marginBottom: '24px' };
const tabContainerStyle = { display: 'flex', borderBottom: '1px solid #e0e0e0', marginBottom: '24px', backgroundColor: '#fff', borderRadius: '8px 8px 0 0', boxShadow: '0 1px 3px rgba(0,0,0,0.1)', padding: '0 8px' };
const tabStyle = { padding: '14px 24px', fontSize: '14px', fontWeight: '500', cursor: 'pointer', border: 'none', background: 'none', color: '#666', borderBottom: '3px solid transparent', transition: 'all 0.2s ease', outline: 'none' };
const tabActiveStyle = { ...tabStyle, fontWeight: '600', color: '#1976d2', borderBottom: '3px solid #1976d2' };
const labelStyle = { display: 'block', fontSize: '13px', fontWeight: '500', color: '#666', marginBottom: '6px' };
const inputStyle = { width: '100%', padding: '10px 12px', fontSize: '14px', border: '1px solid #ddd', borderRadius: '6px', color: '#333', outline: 'none', boxSizing: 'border-box', transition: 'border-color 0.2s ease' };
const selectStyle = { ...inputStyle, appearance: 'auto' };
const fieldGroupStyle = { marginBottom: '20px' };
const btnPrimary = { padding: '10px 24px', fontSize: '14px', fontWeight: '500', color: '#fff', backgroundColor: '#1976d2', border: 'none', borderRadius: '6px', cursor: 'pointer', transition: 'background-color 0.2s ease' };
const btnSecondary = { padding: '10px 24px', fontSize: '14px', fontWeight: '500', color: '#666', backgroundColor: '#f5f5f5', border: '1px solid #ddd', borderRadius: '6px', cursor: 'pointer' };
const btnDanger = { padding: '6px 14px', fontSize: '13px', fontWeight: '500', color: '#fff', backgroundColor: '#d32f2f', border: 'none', borderRadius: '6px', cursor: 'pointer' };
const btnSuccess = { padding: '6px 14px', fontSize: '13px', fontWeight: '500', color: '#fff', backgroundColor: '#2e7d32', border: 'none', borderRadius: '6px', cursor: 'pointer' };
const messageStyle = (tipo) => ({ padding: '12px 16px', borderRadius: '6px', fontSize: '14px', marginBottom: '20px', backgroundColor: tipo === 'sucesso' ? '#e8f5e9' : '#ffebee', color: tipo === 'sucesso' ? '#2e7d32' : '#c62828', border: `1px solid ${tipo === 'sucesso' ? '#c8e6c9' : '#ffcdd2'}` });
const helpTextStyle = { fontSize: '12px', color: '#999', marginTop: '6px' };
const avisoStyle = { padding: '12px 16px', borderRadius: '6px', fontSize: '13px', backgroundColor: '#fff8e1', color: '#f57f17', border: '1px solid #ffecb3', marginBottom: '20px', lineHeight: '1.5' };
const tableStyle = { width: '100%', borderCollapse: 'collapse' };
const thStyle = { padding: '12px 16px', textAlign: 'left', fontSize: '13px', fontWeight: '600', color: '#666', borderBottom: '2px solid #e0e0e0', backgroundColor: '#fafafa' };
const tdStyle = { padding: '12px 16px', fontSize: '14px', borderBottom: '1px solid #f0f0f0', color: '#333' };

// ── Preview helper ───────────────────────────────────────────────────────────
const previewTexto = (texto) => {
  return (texto || '')
    .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
    .replace(/\{nome_paciente\}/g, 'Maria da Silva')
    .replace(/\{primeiro_nome\}/g, 'Maria')
    .replace(/\{protocolo\}/g, '258920')
    .replace(/\{data_atendimento\}/g, new Date().toLocaleDateString('pt-BR'))
    .replace(/\{local_nome\}/g, 'Itapecerica')
    .replace(/\{nome_laboratorio\}/g, 'Laboratório Santa Rita')
    .replace(/\{link_resultado\}/g, 'http://app.lifesys.com.br/laudos/...')
    .replace(/\{protocolo_data\}/g, '258920 de ' + new Date().toLocaleDateString('pt-BR'))
    .replace(/\{data_protocolo\}/g, new Date().toLocaleDateString('pt-BR') + ', protocolo 258920')
    .replace(/\{data_local\}/g, new Date().toLocaleDateString('pt-BR') + ' na unidade Itapecerica')
    .replace(/\{info_atendimento\}/g, 'Protocolo 258920 - ' + new Date().toLocaleDateString('pt-BR'))
    .replace(/\{acesse_link\}/g, 'Acesse seus resultados: http://app.lifesys.com.br/laudos/...')
    .replace(/\{lab_assinatura\}/g, 'Laboratório Santa Rita - Cuidando da sua saúde!')
    .replace(/\{status_exames\}/g, 'Todos os seus 5 exame(s) estão prontos!')
    .replace(/\{total_exames\}/g, '5')
    .replace(/\{exames_prontos\}/g, '5')
    .replace(/\{lista_exames\}/g, '✅ Hemograma - pronto\n✅ Glicose - pronto\n✅ Creatinina - pronto')
    .replace(/\*([^*]+)\*/g, '<strong>$1</strong>')
    .replace(/_([^_]+)_/g, '<em>$1</em>')
    .replace(/~([^~]+)~/g, '<s>$1</s>');
};

const WhatsAppMensagens = () => {
  const [activeTab, setActiveTab] = useState('modelos');
  const [message, setMessage] = useState(null);
  const [loading, setLoading] = useState(false);

  // ── Tab 1: Modelos de Mensagem ─────────────────────────────────────────────
  const [modelos, setModelos] = useState([]);
  const [loadingModelos, setLoadingModelos] = useState(false);
  const [modeloAtivo, setModeloAtivo] = useState(null);
  const [showModeloForm, setShowModeloForm] = useState(false);
  const [editingModelo, setEditingModelo] = useState(null);
  const [modeloFormData, setModeloFormData] = useState({
    nome: '', descricao: '', mensagem_texto: '', tipo_anexo: 'nenhum'
  });

  // ── Tab 2: Sequencias ──────────────────────────────────────────────────────
  const [sequencias, setSequencias] = useState([]);
  const [loadingSequencias, setLoadingSequencias] = useState(false);
  const [editingSequencia, setEditingSequencia] = useState(null);
  const [sequenciaDetalhes, setSequenciaDetalhes] = useState(null);
  const [showSeqForm, setShowSeqForm] = useState(false);
  const [seqFormData, setSeqFormData] = useState({
    nome: '', descricao: '', trigger_tipo: 'manual', trigger_valor: '',
    delay_entre_msgs: 2, parar_no_erro: false
  });

  // Controle de mensagens expandidas (collapsadas por padrão)
  const [expandedMsgs, setExpandedMsgs] = useState({});

  // Mensagens da sequencia em edicao
  const [showMsgForm, setShowMsgForm] = useState(false);
  const [editingMsg, setEditingMsg] = useState(null);
  const [msgFormData, setMsgFormData] = useState({
    mensagem_texto: '', tipo_anexo: 'nenhum', delay_antes: 0
  });

  // Preview & Test
  const [previewData, setPreviewData] = useState(null);
  const [showTestForm, setShowTestForm] = useState(false);
  const [testFormData, setTestFormData] = useState({ telefone: '', solicitacao_id: '' });

  // ── Helpers ────────────────────────────────────────────────────────────────
  const showMsg = (texto, tipo) => {
    setMessage({ texto, tipo });
    setTimeout(() => setMessage(null), 5000);
  };

  // ── useEffect ──────────────────────────────────────────────────────────────
  useEffect(() => {
    carregarModelos();
    carregarSequencias();
  }, []);

  // ══════════════════════════════════════════════════════════════════════════
  // TAB 1 - Modelos de Mensagem (from mensagens_diretas_modelos)
  // ══════════════════════════════════════════════════════════════════════════

  const carregarModelos = async () => {
    setLoadingModelos(true);
    try {
      const response = await axios.get(`${API_URL}/whatsapp/mensagens-diretas`);
      setModelos(response.data);
      const ativo = response.data.find(t => t.ativo);
      setModeloAtivo(ativo || null);
    } catch (error) {
      console.error('Erro ao carregar modelos:', error);
    } finally {
      setLoadingModelos(false);
    }
  };

  const salvarModelo = async () => {
    if (!modeloFormData.nome || !modeloFormData.mensagem_texto) {
      showMsg('Nome e texto da mensagem são obrigatórios.', 'erro');
      return;
    }
    setLoading(true);
    try {
      if (editingModelo) {
        await axios.put(`${API_URL}/whatsapp/mensagens-diretas/${editingModelo.id}`, modeloFormData);
        showMsg('Modelo atualizado com sucesso.', 'sucesso');
      } else {
        await axios.post(`${API_URL}/whatsapp/mensagens-diretas`, modeloFormData);
        showMsg('Modelo criado com sucesso.', 'sucesso');
      }
      setShowModeloForm(false);
      setEditingModelo(null);
      setModeloFormData({ nome: '', descricao: '', mensagem_texto: '', tipo_anexo: 'nenhum' });
      carregarModelos();
    } catch (error) {
      const msg = error.response?.data?.error || 'Erro ao salvar modelo.';
      showMsg(msg, 'erro');
    } finally {
      setLoading(false);
    }
  };

  const excluirModelo = async (id) => {
    try {
      await axios.delete(`${API_URL}/whatsapp/mensagens-diretas/${id}`);
      showMsg('Modelo excluído com sucesso.', 'sucesso');
      carregarModelos();
    } catch (error) {
      const msg = error.response?.data?.error || 'Erro ao excluir modelo.';
      showMsg(msg, 'erro');
    }
  };

  const ativarModelo = async (id) => {
    try {
      await axios.post(`${API_URL}/whatsapp/mensagens-diretas/${id}/ativar`);
      showMsg('Modelo ativado com sucesso.', 'sucesso');
      carregarModelos();
    } catch (error) {
      const msg = error.response?.data?.error || 'Erro ao ativar modelo.';
      showMsg(msg, 'erro');
    }
  };

  const abrirEditarModelo = (modelo) => {
    setEditingModelo(modelo);
    setModeloFormData({
      nome: modelo.nome,
      descricao: modelo.descricao || '',
      mensagem_texto: modelo.mensagem_texto,
      tipo_anexo: modelo.tipo_anexo || 'nenhum',
    });
    setShowModeloForm(true);
  };

  const abrirNovoModelo = () => {
    setEditingModelo(null);
    setModeloFormData({ nome: '', descricao: '', mensagem_texto: '', tipo_anexo: 'nenhum' });
    setShowModeloForm(true);
  };

  // ══════════════════════════════════════════════════════════════════════════
  // TAB 2 - Sequencias
  // ══════════════════════════════════════════════════════════════════════════

  const carregarSequencias = async () => {
    setLoadingSequencias(true);
    try {
      const response = await axios.get(`${API_URL}/whatsapp/sequencias`);
      setSequencias(response.data);
    } catch (error) {
      console.error('Erro ao carregar sequências:', error);
    } finally {
      setLoadingSequencias(false);
    }
  };

  const carregarDetalhesSequencia = async (id) => {
    try {
      const response = await axios.get(`${API_URL}/whatsapp/sequencias/${id}`);
      setSequenciaDetalhes(response.data);
    } catch (error) {
      console.error('Erro ao carregar detalhes da sequência:', error);
      showMsg('Erro ao carregar detalhes da sequência.', 'erro');
    }
  };

  const salvarSequencia = async () => {
    if (!seqFormData.nome) {
      showMsg('Nome da sequência é obrigatório.', 'erro');
      return;
    }
    setLoading(true);
    try {
      if (editingSequencia) {
        await axios.put(`${API_URL}/whatsapp/sequencias/${editingSequencia.id}`, seqFormData);
        showMsg('Sequência atualizada com sucesso.', 'sucesso');
        await carregarDetalhesSequencia(editingSequencia.id);
      } else {
        const response = await axios.post(`${API_URL}/whatsapp/sequencias`, seqFormData);
        showMsg('Sequência criada com sucesso.', 'sucesso');
        const novaSeq = response.data;
        setEditingSequencia(novaSeq);
        await carregarDetalhesSequencia(novaSeq.id);
      }
      setShowSeqForm(false);
      carregarSequencias();
    } catch (error) {
      const msg = error.response?.data?.error || 'Erro ao salvar sequência.';
      showMsg(msg, 'erro');
    } finally {
      setLoading(false);
    }
  };

  const excluirSequencia = async (id) => {
    try {
      await axios.delete(`${API_URL}/whatsapp/sequencias/${id}`);
      showMsg('Sequência excluída com sucesso.', 'sucesso');
      if (editingSequencia && editingSequencia.id === id) {
        setEditingSequencia(null);
        setSequenciaDetalhes(null);
      }
      carregarSequencias();
    } catch (error) {
      const msg = error.response?.data?.error || 'Erro ao excluir sequência.';
      showMsg(msg, 'erro');
    }
  };

  const toggleAtivoSequencia = async (id) => {
    try {
      await axios.post(`${API_URL}/whatsapp/sequencias/${id}/ativar`);
      showMsg('Status atualizado com sucesso.', 'sucesso');
      carregarSequencias();
      if (sequenciaDetalhes && sequenciaDetalhes.id === id) {
        await carregarDetalhesSequencia(id);
      }
    } catch (error) {
      const msg = error.response?.data?.error || 'Erro ao alterar status.';
      showMsg(msg, 'erro');
    }
  };

  const abrirEditarSequencia = async (seq) => {
    setEditingSequencia(seq);
    setSeqFormData({
      nome: seq.nome,
      descricao: seq.descricao || '',
      trigger_tipo: seq.trigger_tipo || 'manual',
      trigger_valor: seq.trigger_valor || '',
      delay_entre_msgs: seq.delay_entre_msgs != null ? seq.delay_entre_msgs : 2,
      parar_no_erro: seq.parar_no_erro ? true : false,
    });
    setShowSeqForm(true);
    setPreviewData(null);
    setShowTestForm(false);
    await carregarDetalhesSequencia(seq.id);
  };

  const abrirNovaSequencia = () => {
    setEditingSequencia(null);
    setSequenciaDetalhes(null);
    setSeqFormData({
      nome: '', descricao: '', trigger_tipo: 'manual', trigger_valor: '',
      delay_entre_msgs: 2, parar_no_erro: false
    });
    setShowSeqForm(true);
    setPreviewData(null);
    setShowTestForm(false);
  };

  const fecharEdicaoSequencia = () => {
    setEditingSequencia(null);
    setSequenciaDetalhes(null);
    setShowSeqForm(false);
    setShowMsgForm(false);
    setEditingMsg(null);
    setPreviewData(null);
    setShowTestForm(false);
  };

  // ── Mensagens da Sequencia ─────────────────────────────────────────────────

  const adicionarMensagem = async () => {
    if (!editingSequencia) return;
    if (!msgFormData.mensagem_texto) {
      showMsg('Texto da mensagem é obrigatório.', 'erro');
      return;
    }
    setLoading(true);
    try {
      await axios.post(`${API_URL}/whatsapp/sequencias/${editingSequencia.id}/mensagens`, msgFormData);
      showMsg('Mensagem adicionada com sucesso.', 'sucesso');
      setShowMsgForm(false);
      setEditingMsg(null);
      setMsgFormData({ mensagem_texto: '', tipo_anexo: 'nenhum', delay_antes: 0 });
      await carregarDetalhesSequencia(editingSequencia.id);
    } catch (error) {
      const msg = error.response?.data?.error || 'Erro ao adicionar mensagem.';
      showMsg(msg, 'erro');
    } finally {
      setLoading(false);
    }
  };

  const atualizarMensagem = async () => {
    if (!editingSequencia || !editingMsg) return;
    if (!msgFormData.mensagem_texto) {
      showMsg('Texto da mensagem é obrigatório.', 'erro');
      return;
    }
    setLoading(true);
    try {
      await axios.put(`${API_URL}/whatsapp/sequencias/${editingSequencia.id}/mensagens/${editingMsg.id}`, msgFormData);
      showMsg('Mensagem atualizada com sucesso.', 'sucesso');
      setShowMsgForm(false);
      setEditingMsg(null);
      setMsgFormData({ mensagem_texto: '', tipo_anexo: 'nenhum', delay_antes: 0 });
      await carregarDetalhesSequencia(editingSequencia.id);
    } catch (error) {
      const msg = error.response?.data?.error || 'Erro ao atualizar mensagem.';
      showMsg(msg, 'erro');
    } finally {
      setLoading(false);
    }
  };

  const excluirMensagem = async (msgId) => {
    if (!editingSequencia) return;
    try {
      await axios.delete(`${API_URL}/whatsapp/sequencias/${editingSequencia.id}/mensagens/${msgId}`);
      showMsg('Mensagem excluída com sucesso.', 'sucesso');
      await carregarDetalhesSequencia(editingSequencia.id);
    } catch (error) {
      const msg = error.response?.data?.error || 'Erro ao excluir mensagem.';
      showMsg(msg, 'erro');
    }
  };

  const moverMensagem = async (msgId, direcao) => {
    if (!editingSequencia || !sequenciaDetalhes) return;
    const msgs = sequenciaDetalhes.mensagens || [];
    const idx = msgs.findIndex(m => m.id === msgId);
    if (idx < 0) return;
    const newIdx = direcao === 'up' ? idx - 1 : idx + 1;
    if (newIdx < 0 || newIdx >= msgs.length) return;

    const novaOrdem = msgs.map(m => m.id);
    [novaOrdem[idx], novaOrdem[newIdx]] = [novaOrdem[newIdx], novaOrdem[idx]];

    try {
      await axios.post(`${API_URL}/whatsapp/sequencias/${editingSequencia.id}/mensagens/reordenar`, {
        ordem: novaOrdem
      });
      await carregarDetalhesSequencia(editingSequencia.id);
    } catch (error) {
      const msg = error.response?.data?.error || 'Erro ao reordenar mensagens.';
      showMsg(msg, 'erro');
    }
  };

  const abrirEditarMsg = (msg) => {
    setEditingMsg(msg);
    setMsgFormData({
      mensagem_texto: msg.mensagem_texto,
      tipo_anexo: msg.tipo_anexo || 'nenhum',
      delay_antes: msg.delay_antes || 0,
    });
    setShowMsgForm(true);
  };

  const abrirNovaMsg = () => {
    setEditingMsg(null);
    setMsgFormData({ mensagem_texto: '', tipo_anexo: 'nenhum', delay_antes: 0 });
    setShowMsgForm(true);
  };

  // ── Preview & Test ─────────────────────────────────────────────────────────

  const previewSequencia = async () => {
    if (!editingSequencia) return;
    try {
      const response = await axios.post(`${API_URL}/whatsapp/sequencias/${editingSequencia.id}/preview`);
      setPreviewData(response.data);
    } catch (error) {
      const msg = error.response?.data?.error || 'Erro ao gerar preview.';
      showMsg(msg, 'erro');
    }
  };

  const executarTeste = async () => {
    if (!editingSequencia || !testFormData.telefone) {
      showMsg('Telefone é obrigatório para o teste.', 'erro');
      return;
    }
    setLoading(true);
    try {
      await axios.post(`${API_URL}/whatsapp/sequencias/${editingSequencia.id}/executar`, {
        telefone: testFormData.telefone,
        solicitacao_id: testFormData.solicitacao_id || undefined,
      });
      showMsg('Execução iniciada com sucesso!', 'sucesso');
      setShowTestForm(false);
      setTestFormData({ telefone: '', solicitacao_id: '' });
    } catch (error) {
      const msg = error.response?.data?.error || 'Erro ao executar sequência.';
      showMsg(msg, 'erro');
    } finally {
      setLoading(false);
    }
  };

  // ══════════════════════════════════════════════════════════════════════════
  // RENDER - Tab 1: Modelos de Mensagem
  // ══════════════════════════════════════════════════════════════════════════

  const renderModelos = () => (
    <div>
      {/* Card do modelo ativo */}
      <div style={{
        ...cardStyle, borderLeft: '4px solid #7b1fa2',
        backgroundColor: modeloAtivo ? '#faf5ff' : '#fff',
      }}>
        <h3 style={{ fontSize: '16px', fontWeight: '600', color: '#333', marginTop: 0, marginBottom: '12px' }}>
          Modelo Ativo para Envio Direto
        </h3>
        {modeloAtivo ? (
          <div>
            <div style={{ display: 'flex', flexWrap: 'wrap', gap: '24px', alignItems: 'center', marginBottom: '12px' }}>
              <div>
                <span style={{ fontSize: '12px', color: '#999' }}>Nome</span>
                <div style={{ fontSize: '15px', fontWeight: '500', color: '#7b1fa2' }}>
                  {modeloAtivo.nome}
                </div>
              </div>
              <div>
                <span style={{ fontSize: '12px', color: '#999' }}>Anexo</span>
                <div style={{ fontSize: '14px', color: '#333' }}>
                  {modeloAtivo.tipo_anexo === 'pdf_resultado' ? 'PDF do Resultado' : 'Nenhum'}
                </div>
              </div>
            </div>
            <div style={{
              backgroundColor: '#f3e5f5', borderRadius: '8px', padding: '16px',
              border: '1px solid #ce93d8',
            }}>
              <span style={{ fontSize: '12px', color: '#666', fontWeight: '500' }}>Pré-visualização:</span>
              <div style={{ marginTop: '8px', fontSize: '14px', color: '#333', whiteSpace: 'pre-wrap', lineHeight: '1.5' }}
                dangerouslySetInnerHTML={{ __html: previewTexto(modeloAtivo.mensagem_texto) }} />
            </div>
          </div>
        ) : (
          <p style={{ color: '#999', fontSize: '14px', margin: 0 }}>
            Nenhum modelo ativo. Crie um modelo e ative-o para uso no envio direto.
          </p>
        )}
      </div>

      {/* Info box */}
      <div style={avisoStyle}>
        <strong>Como funciona o envio direto (Session Messages):</strong><br />
        1. Envie um <strong>template de abertura</strong> simples (aprovado pela Meta) para iniciar a conversa<br />
        2. Quando o paciente <strong>responder</strong>, a janela de 24h se abre<br />
        3. Dentro da janela, envie <strong>mensagens diretas gratuitas</strong> com resultados e PDF<br />
        Isso economiza custos com templates complexos da Meta.
      </div>

      {/* Barra de acoes + tabela */}
      <div style={cardStyle}>
        <div className="responsive-flex" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}>
          <h3 style={{ fontSize: '16px', fontWeight: '600', color: '#333', margin: 0 }}>
            Modelos de Mensagem Direta
          </h3>
          <button type="button" style={{ ...btnPrimary, backgroundColor: '#7b1fa2' }} onClick={abrirNovoModelo}>
            + Criar Novo
          </button>
        </div>

        {/* Formulario criar/editar */}
        {showModeloForm && (
          <div style={{
            backgroundColor: '#fafafa', border: '1px solid #e0e0e0', borderRadius: '8px',
            padding: '24px', marginBottom: '20px',
          }}>
            <h4 style={{ fontSize: '15px', fontWeight: '600', color: '#333', marginTop: 0, marginBottom: '16px' }}>
              {editingModelo ? 'Editar Modelo' : 'Criar Novo Modelo'}
            </h4>

            <div className="responsive-grid" style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '16px', marginBottom: '16px' }}>
              <div style={fieldGroupStyle}>
                <label style={labelStyle}>Nome *</label>
                <input type="text" style={inputStyle} value={modeloFormData.nome}
                  onChange={(e) => setModeloFormData({ ...modeloFormData, nome: e.target.value })}
                  placeholder="Ex: Resultado com Link" />
              </div>
              <div style={fieldGroupStyle}>
                <label style={labelStyle}>Tipo de Anexo</label>
                <select style={selectStyle} value={modeloFormData.tipo_anexo}
                  onChange={(e) => setModeloFormData({ ...modeloFormData, tipo_anexo: e.target.value })}>
                  <option value="nenhum">Nenhum (apenas texto)</option>
                  <option value="pdf_resultado">PDF do Resultado</option>
                </select>
              </div>
            </div>

            <div style={fieldGroupStyle}>
              <label style={labelStyle}>Descrição</label>
              <input type="text" style={inputStyle} value={modeloFormData.descricao}
                onChange={(e) => setModeloFormData({ ...modeloFormData, descricao: e.target.value })}
                placeholder="Breve descrição do modelo" />
            </div>

            <div style={fieldGroupStyle}>
              <label style={labelStyle}>Texto da Mensagem *</label>
              <textarea style={{ ...inputStyle, minHeight: '120px', resize: 'vertical', fontFamily: 'inherit' }}
                value={modeloFormData.mensagem_texto}
                onChange={(e) => setModeloFormData({ ...modeloFormData, mensagem_texto: e.target.value })}
                placeholder="✅ *Resultados Disponíveis*\n\nOlá, *{nome_paciente}*!..." />
              <p style={helpTextStyle}>
                Basicas: {'{nome_paciente}'}, {'{primeiro_nome}'}, {'{protocolo}'}, {'{data_atendimento}'}, {'{local_nome}'}, {'{nome_laboratorio}'}, {'{link_resultado}'}
                <br />Compostas: {'{protocolo_data}'}, {'{data_protocolo}'}, {'{data_local}'}, {'{info_atendimento}'}, {'{acesse_link}'}, {'{lab_assinatura}'}
                <br />Exames: {'{status_exames}'}, {'{total_exames}'}, {'{exames_prontos}'}, {'{lista_exames}'}
                <br />Formatacao WhatsApp: *negrito*, _italico_, ~tachado~
              </p>
            </div>

            {/* Preview ao vivo */}
            {modeloFormData.mensagem_texto && (
              <div style={{
                backgroundColor: '#f3e5f5', borderRadius: '8px', padding: '16px', marginBottom: '16px',
                border: '1px solid #ce93d8',
              }}>
                <span style={{ fontSize: '12px', color: '#666', fontWeight: '500' }}>Pré-visualização:</span>
                <div style={{ marginTop: '8px', fontSize: '14px', color: '#333', whiteSpace: 'pre-wrap', lineHeight: '1.5' }}
                  dangerouslySetInnerHTML={{ __html: previewTexto(modeloFormData.mensagem_texto) }} />
              </div>
            )}

            <div style={{ display: 'flex', gap: '12px' }}>
              <button type="button" style={{ ...btnPrimary, backgroundColor: '#7b1fa2', opacity: loading ? 0.7 : 1 }}
                onClick={salvarModelo} disabled={loading}>
                {loading ? 'Salvando...' : (editingModelo ? 'Salvar Alterações' : 'Criar Modelo')}
              </button>
              <button type="button" style={btnSecondary} onClick={() => { setShowModeloForm(false); setEditingModelo(null); }}>
                Cancelar
              </button>
            </div>
          </div>
        )}

        {/* Tabela de modelos */}
        {loadingModelos ? (
          <div style={{ textAlign: 'center', padding: '40px 20px', color: '#999' }}>
            Carregando modelos...
          </div>
        ) : modelos.length > 0 ? (
          <div style={{ overflowX: 'auto' }}>
            <table style={tableStyle}>
              <thead>
                <tr>
                  <th style={thStyle}>Nome</th>
                  <th style={thStyle}>Descrição</th>
                  <th style={thStyle}>Anexo</th>
                  <th style={thStyle}>Status</th>
                  <th style={{ ...thStyle, textAlign: 'right' }}>Ações</th>
                </tr>
              </thead>
              <tbody>
                {modelos.map((modelo, idx) => (
                  <tr key={modelo.id} style={{ backgroundColor: idx % 2 === 0 ? '#fff' : '#fafafa' }}>
                    <td style={{ ...tdStyle, fontWeight: '500' }}>{modelo.nome}</td>
                    <td style={{ ...tdStyle, color: '#666', maxWidth: '200px', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                      {modelo.descricao || '-'}
                    </td>
                    <td style={tdStyle}>
                      {modelo.tipo_anexo === 'pdf_resultado' ? (
                        <span style={{ padding: '3px 10px', borderRadius: '12px', fontSize: '12px', fontWeight: '500', backgroundColor: '#fff3e0', color: '#e65100' }}>
                          PDF
                        </span>
                      ) : (
                        <span style={{ fontSize: '13px', color: '#999' }}>Nenhum</span>
                      )}
                    </td>
                    <td style={tdStyle}>
                      {modelo.ativo ? (
                        <span style={{ padding: '3px 10px', borderRadius: '12px', fontSize: '12px', fontWeight: '600', backgroundColor: '#f3e5f5', color: '#7b1fa2' }}>
                          Ativo
                        </span>
                      ) : (
                        <span style={{ fontSize: '13px', color: '#999' }}>Inativo</span>
                      )}
                    </td>
                    <td style={{ ...tdStyle, textAlign: 'right', whiteSpace: 'nowrap' }}>
                      {!modelo.ativo && (
                        <button type="button" style={{ ...btnSuccess, marginRight: '8px', backgroundColor: '#7b1fa2' }}
                          onClick={() => ativarModelo(modelo.id)}>
                          Ativar
                        </button>
                      )}
                      <button type="button" style={{ ...btnSecondary, padding: '6px 14px', fontSize: '13px', marginRight: '8px' }}
                        onClick={() => abrirEditarModelo(modelo)}>
                        Editar
                      </button>
                      {!modelo.ativo && (
                        <button type="button" style={btnDanger}
                          onClick={() => {
                            if (window.confirm(`Excluir o modelo "${modelo.nome}"?`)) {
                              excluirModelo(modelo.id);
                            }
                          }}>
                          Excluir
                        </button>
                      )}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        ) : (
          <div style={{ textAlign: 'center', padding: '40px 20px', color: '#999' }}>
            <p style={{ fontSize: '14px', margin: 0 }}>Nenhum modelo encontrado.</p>
            <p style={{ fontSize: '12px', marginTop: '8px', color: '#bbb' }}>
              Clique em "Criar Novo" para adicionar um modelo de mensagem direta.
            </p>
          </div>
        )}
      </div>
    </div>
  );

  // ══════════════════════════════════════════════════════════════════════════
  // RENDER - Tab 2: Sequencias
  // ══════════════════════════════════════════════════════════════════════════

  const triggerBadge = (tipo) => {
    const map = {
      botao_confirmacao: { label: 'Botão', bg: '#e8f5e9', color: '#2e7d32' },
      palavra_chave: { label: 'Palavra-chave', bg: '#e3f2fd', color: '#1565c0' },
      manual: { label: 'Manual', bg: '#f5f5f5', color: '#666' },
    };
    const cfg = map[tipo] || map.manual;
    return (
      <span style={{ padding: '3px 10px', borderRadius: '12px', fontSize: '12px', fontWeight: '500', backgroundColor: cfg.bg, color: cfg.color }}>
        {cfg.label}
      </span>
    );
  };

  const renderSequencias = () => (
    <div>
      {/* Se estiver editando, mostrar inline */}
      {(editingSequencia || showSeqForm) ? renderSequenciaEdit() : renderSequenciaList()}
    </div>
  );

  const renderSequenciaList = () => (
    <div>
      <div style={{ marginBottom: '20px' }}>
        <button type="button" style={btnPrimary} onClick={abrirNovaSequencia}>
          + Nova Sequência
        </button>
      </div>

      {loadingSequencias ? (
        <div style={{ textAlign: 'center', padding: '40px 20px', color: '#999' }}>
          Carregando sequências...
        </div>
      ) : sequencias.length > 0 ? (
        <div style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
          {sequencias.map((seq) => (
            <div key={seq.id} style={{
              ...cardStyle, marginBottom: 0,
              borderLeft: seq.ativo ? '4px solid #2e7d32' : '4px solid #bdbdbd',
            }}>
              <div className="responsive-flex" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', gap: '16px' }}>
                <div style={{ flex: 1 }}>
                  <div style={{ display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '8px', flexWrap: 'wrap' }}>
                    <span style={{ fontSize: '16px', fontWeight: '600', color: '#333' }}>{seq.nome}</span>
                    {triggerBadge(seq.trigger_tipo)}
                    {seq.trigger_valor && (
                      <span style={{ fontSize: '12px', color: '#1565c0', backgroundColor: '#e3f2fd', padding: '2px 8px', borderRadius: '8px' }}>
                        {seq.trigger_valor}
                      </span>
                    )}
                    <span style={{ fontSize: '12px', color: '#999' }}>
                      {seq.total_mensagens || 0} mensagen{(seq.total_mensagens || 0) !== 1 ? 's' : ''}
                    </span>
                  </div>
                  {seq.descricao && (
                    <p style={{ fontSize: '13px', color: '#666', margin: 0, maxWidth: '500px', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                      {seq.descricao}
                    </p>
                  )}
                </div>

                <div style={{ display: 'flex', alignItems: 'center', gap: '12px', flexShrink: 0 }}>
                  {/* Toggle ativo */}
                  <label style={{ display: 'flex', alignItems: 'center', gap: '8px', cursor: 'pointer', fontSize: '13px', color: '#666' }}>
                    <div
                      onClick={() => toggleAtivoSequencia(seq.id)}
                      style={{
                        width: '44px', height: '24px', borderRadius: '12px', position: 'relative',
                        backgroundColor: seq.ativo ? '#2e7d32' : '#bdbdbd', transition: 'background-color 0.2s', cursor: 'pointer',
                      }}
                    >
                      <div style={{
                        width: '20px', height: '20px', borderRadius: '50%', backgroundColor: '#fff',
                        position: 'absolute', top: '2px', transition: 'left 0.2s',
                        left: seq.ativo ? '22px' : '2px', boxShadow: '0 1px 3px rgba(0,0,0,0.2)',
                      }} />
                    </div>
                    {seq.ativo ? 'Ativo' : 'Inativo'}
                  </label>

                  <button type="button" style={{ ...btnSecondary, padding: '6px 14px', fontSize: '13px' }}
                    onClick={() => abrirEditarSequencia(seq)}>
                    Editar
                  </button>
                  <button type="button" style={btnDanger}
                    onClick={() => {
                      if (window.confirm(`Excluir a sequência "${seq.nome}"?`)) {
                        excluirSequencia(seq.id);
                      }
                    }}>
                    Excluir
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>
      ) : (
        <div style={{ ...cardStyle, textAlign: 'center', padding: '40px 20px', color: '#999' }}>
          <p style={{ fontSize: '14px', margin: 0 }}>Nenhuma sequência encontrada.</p>
          <p style={{ fontSize: '12px', marginTop: '8px', color: '#bbb' }}>
            Clique em "+ Nova Sequência" para criar uma sequência de mensagens.
          </p>
        </div>
      )}
    </div>
  );

  const renderSequenciaEdit = () => {
    const msgs = sequenciaDetalhes?.mensagens || [];

    return (
      <div>
        {/* Voltar */}
        <div style={{ marginBottom: '16px' }}>
          <button type="button" style={btnSecondary} onClick={fecharEdicaoSequencia}>
            &larr; Voltar para lista
          </button>
        </div>

        {/* Formulario da sequencia */}
        <div style={cardStyle}>
          <h3 style={{ fontSize: '16px', fontWeight: '600', color: '#333', marginTop: 0, marginBottom: '20px' }}>
            {editingSequencia ? `Editar Sequência: ${editingSequencia.nome}` : 'Nova Sequência'}
          </h3>

          {showSeqForm && (
            <div style={{ marginBottom: '24px' }}>
              <div className="responsive-grid" style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '16px', marginBottom: '16px' }}>
                <div style={fieldGroupStyle}>
                  <label style={labelStyle}>Nome *</label>
                  <input type="text" style={inputStyle} value={seqFormData.nome}
                    onChange={(e) => setSeqFormData({ ...seqFormData, nome: e.target.value })}
                    placeholder="Ex: Envio de resultados" />
                </div>
                <div style={fieldGroupStyle}>
                  <label style={labelStyle}>Trigger</label>
                  <select style={selectStyle} value={seqFormData.trigger_tipo}
                    onChange={(e) => setSeqFormData({ ...seqFormData, trigger_tipo: e.target.value })}>
                    <option value="manual">Manual</option>
                    <option value="botao_confirmacao">Botão de confirmação</option>
                    <option value="palavra_chave">Palavra-chave</option>
                  </select>
                </div>
              </div>

              <div style={fieldGroupStyle}>
                <label style={labelStyle}>Descrição</label>
                <input type="text" style={inputStyle} value={seqFormData.descricao}
                  onChange={(e) => setSeqFormData({ ...seqFormData, descricao: e.target.value })}
                  placeholder="Breve descrição da sequência" />
              </div>

              {seqFormData.trigger_tipo === 'palavra_chave' && (
                <div style={fieldGroupStyle}>
                  <label style={labelStyle}>Palavra-chave (trigger_valor)</label>
                  <input type="text" style={inputStyle} value={seqFormData.trigger_valor}
                    onChange={(e) => setSeqFormData({ ...seqFormData, trigger_valor: e.target.value })}
                    placeholder="Ex: resultado, laudo" />
                  <p style={helpTextStyle}>Quando o paciente enviar essa palavra, a sequência será disparada automaticamente.</p>
                </div>
              )}

              <div className="responsive-grid" style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '16px', marginBottom: '16px' }}>
                <div style={fieldGroupStyle}>
                  <label style={labelStyle}>Delay entre mensagens (segundos)</label>
                  <input type="number" style={inputStyle} value={seqFormData.delay_entre_msgs}
                    onChange={(e) => setSeqFormData({ ...seqFormData, delay_entre_msgs: parseInt(e.target.value) || 0 })}
                    min="0" />
                  <p style={helpTextStyle}>Tempo de espera entre o envio de cada mensagem da sequência.</p>
                </div>
                <div style={{ ...fieldGroupStyle, display: 'flex', alignItems: 'center', gap: '10px', paddingTop: '24px' }}>
                  <input type="checkbox" id="parar_no_erro"
                    checked={seqFormData.parar_no_erro}
                    onChange={(e) => setSeqFormData({ ...seqFormData, parar_no_erro: e.target.checked })}
                    style={{ width: '18px', height: '18px', cursor: 'pointer' }} />
                  <label htmlFor="parar_no_erro" style={{ fontSize: '14px', color: '#333', cursor: 'pointer' }}>
                    Parar no erro (interrompe a sequência se uma mensagem falhar)
                  </label>
                </div>
              </div>

              <div style={{ display: 'flex', gap: '12px' }}>
                <button type="button" style={{ ...btnPrimary, opacity: loading ? 0.7 : 1 }}
                  onClick={salvarSequencia} disabled={loading}>
                  {loading ? 'Salvando...' : (editingSequencia ? 'Salvar Alterações' : 'Criar Sequência')}
                </button>
                {!editingSequencia && (
                  <button type="button" style={btnSecondary} onClick={fecharEdicaoSequencia}>
                    Cancelar
                  </button>
                )}
              </div>
            </div>
          )}

          {/* Mostrar/ocultar form se ja editando */}
          {editingSequencia && !showSeqForm && (
            <button type="button" style={{ ...btnSecondary, fontSize: '13px', marginBottom: '16px' }}
              onClick={() => setShowSeqForm(true)}>
              Editar dados da sequência
            </button>
          )}
        </div>

        {/* Mensagens da sequencia */}
        {editingSequencia && (
          <div style={cardStyle}>
            <div className="responsive-flex" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}>
              <h3 style={{ fontSize: '16px', fontWeight: '600', color: '#333', margin: 0 }}>
                Mensagens da Sequência ({msgs.length})
              </h3>
              <button type="button" style={btnPrimary} onClick={abrirNovaMsg}>
                + Adicionar Mensagem
              </button>
            </div>

            {/* Formulario de mensagem */}
            {showMsgForm && (
              <div style={{
                backgroundColor: '#fafafa', border: '1px solid #e0e0e0', borderRadius: '8px',
                padding: '24px', marginBottom: '20px',
              }}>
                <h4 style={{ fontSize: '15px', fontWeight: '600', color: '#333', marginTop: 0, marginBottom: '16px' }}>
                  {editingMsg ? 'Editar Mensagem' : 'Nova Mensagem'}
                </h4>

                <div className="responsive-grid" style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '16px', marginBottom: '16px' }}>
                  <div style={fieldGroupStyle}>
                    <label style={labelStyle}>Tipo de Anexo</label>
                    <select style={selectStyle} value={msgFormData.tipo_anexo}
                      onChange={(e) => setMsgFormData({ ...msgFormData, tipo_anexo: e.target.value })}>
                      <option value="nenhum">Nenhum (apenas texto)</option>
                      <option value="pdf_resultado">PDF do Resultado</option>
                    </select>
                  </div>
                  <div style={fieldGroupStyle}>
                    <label style={labelStyle}>Delay antes (segundos)</label>
                    <input type="number" style={inputStyle} value={msgFormData.delay_antes}
                      onChange={(e) => setMsgFormData({ ...msgFormData, delay_antes: parseInt(e.target.value) || 0 })}
                      min="0" />
                    <p style={helpTextStyle}>Espera adicional antes de enviar esta mensagem.</p>
                  </div>
                </div>

                <div style={fieldGroupStyle}>
                  <label style={labelStyle}>Texto da Mensagem *</label>
                  <textarea style={{ ...inputStyle, minHeight: '120px', resize: 'vertical', fontFamily: 'inherit' }}
                    value={msgFormData.mensagem_texto}
                    onChange={(e) => setMsgFormData({ ...msgFormData, mensagem_texto: e.target.value })}
                    placeholder="Digite o texto da mensagem..." />
                  <p style={helpTextStyle}>
                    Basicas: {'{nome_paciente}'}, {'{primeiro_nome}'}, {'{protocolo}'}, {'{data_atendimento}'}, {'{local_nome}'}, {'{nome_laboratorio}'}, {'{link_resultado}'}
                    <br />Compostas: {'{protocolo_data}'}, {'{data_protocolo}'}, {'{data_local}'}, {'{info_atendimento}'}, {'{acesse_link}'}, {'{lab_assinatura}'}
                    <br />Exames: {'{status_exames}'}, {'{total_exames}'}, {'{exames_prontos}'}, {'{lista_exames}'}
                    <br />Formatacao WhatsApp: *negrito*, _italico_, ~tachado~
                  </p>
                </div>

                {/* Preview ao vivo */}
                {msgFormData.mensagem_texto && (
                  <div style={{
                    backgroundColor: '#f3e5f5', borderRadius: '8px', padding: '16px', marginBottom: '16px',
                    border: '1px solid #ce93d8',
                  }}>
                    <span style={{ fontSize: '12px', color: '#666', fontWeight: '500' }}>Pré-visualização:</span>
                    <div style={{ marginTop: '8px', fontSize: '14px', color: '#333', whiteSpace: 'pre-wrap', lineHeight: '1.5' }}
                      dangerouslySetInnerHTML={{ __html: previewTexto(msgFormData.mensagem_texto) }} />
                  </div>
                )}

                <div style={{ display: 'flex', gap: '12px' }}>
                  <button type="button" style={{ ...btnPrimary, opacity: loading ? 0.7 : 1 }}
                    onClick={editingMsg ? atualizarMensagem : adicionarMensagem} disabled={loading}>
                    {loading ? 'Salvando...' : (editingMsg ? 'Salvar Alterações' : 'Adicionar Mensagem')}
                  </button>
                  <button type="button" style={btnSecondary}
                    onClick={() => { setShowMsgForm(false); setEditingMsg(null); }}>
                    Cancelar
                  </button>
                </div>
              </div>
            )}

            {/* Lista de mensagens */}
            {msgs.length > 0 ? (
              <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
                {msgs.map((msg, idx) => (
                  <div key={msg.id} style={{
                    backgroundColor: '#fafafa', border: '1px solid #e0e0e0', borderRadius: '8px',
                    padding: '16px', display: 'flex', alignItems: 'flex-start', gap: '16px',
                  }}>
                    {/* Order number */}
                    <div style={{
                      width: '32px', height: '32px', borderRadius: '50%', backgroundColor: '#1976d2',
                      color: '#fff', display: 'flex', alignItems: 'center', justifyContent: 'center',
                      fontSize: '14px', fontWeight: '600', flexShrink: 0,
                    }}>
                      {idx + 1}
                    </div>

                    {/* Content */}
                    <div style={{ flex: 1, minWidth: 0 }}>
                      <div
                        style={{
                          fontSize: '14px', color: '#333', marginBottom: '6px', cursor: 'pointer',
                          ...(expandedMsgs[msg.id]
                            ? { whiteSpace: 'pre-wrap', lineHeight: '1.5' }
                            : { overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }),
                        }}
                        onClick={() => setExpandedMsgs(prev => ({ ...prev, [msg.id]: !prev[msg.id] }))}
                        title={expandedMsgs[msg.id] ? 'Clique para colapsar' : 'Clique para expandir'}
                      >
                        {msg.mensagem_texto}
                      </div>
                      <div style={{ display: 'flex', gap: '8px', alignItems: 'center', flexWrap: 'wrap' }}>
                        {msg.tipo_anexo && msg.tipo_anexo !== 'nenhum' && (
                          <span style={{ padding: '2px 8px', borderRadius: '10px', fontSize: '11px', fontWeight: '500', backgroundColor: '#fff3e0', color: '#e65100' }}>
                            {msg.tipo_anexo === 'pdf_resultado' ? 'PDF' : msg.tipo_anexo}
                          </span>
                        )}
                        {(msg.delay_antes > 0) && (
                          <span style={{ fontSize: '12px', color: '#999' }}>
                            Delay: {msg.delay_antes}s
                          </span>
                        )}
                      </div>
                    </div>

                    {/* Actions */}
                    <div style={{ display: 'flex', gap: '6px', flexShrink: 0, alignItems: 'center' }}>
                      <button type="button"
                        style={{ ...btnSecondary, padding: '4px 8px', fontSize: '12px', opacity: idx === 0 ? 0.4 : 1 }}
                        onClick={() => moverMensagem(msg.id, 'up')}
                        disabled={idx === 0}
                        title="Mover para cima">
                        &uarr;
                      </button>
                      <button type="button"
                        style={{ ...btnSecondary, padding: '4px 8px', fontSize: '12px', opacity: idx === msgs.length - 1 ? 0.4 : 1 }}
                        onClick={() => moverMensagem(msg.id, 'down')}
                        disabled={idx === msgs.length - 1}
                        title="Mover para baixo">
                        &darr;
                      </button>
                      <button type="button"
                        style={{ ...btnSecondary, padding: '4px 8px', fontSize: '12px' }}
                        onClick={() => abrirEditarMsg(msg)}>
                        Editar
                      </button>
                      <button type="button"
                        style={{ ...btnDanger, padding: '4px 8px', fontSize: '12px' }}
                        onClick={() => {
                          if (window.confirm('Excluir esta mensagem?')) {
                            excluirMensagem(msg.id);
                          }
                        }}>
                        Excluir
                      </button>
                    </div>
                  </div>
                ))}
              </div>
            ) : (
              <div style={{ textAlign: 'center', padding: '30px 20px', color: '#999' }}>
                <p style={{ fontSize: '14px', margin: 0 }}>Nenhuma mensagem na sequência.</p>
                <p style={{ fontSize: '12px', marginTop: '8px', color: '#bbb' }}>
                  Clique em "+ Adicionar Mensagem" para adicionar.
                </p>
              </div>
            )}
          </div>
        )}

        {/* Preview & Test buttons */}
        {editingSequencia && (
          <div style={cardStyle}>
            <h3 style={{ fontSize: '16px', fontWeight: '600', color: '#333', marginTop: 0, marginBottom: '16px' }}>
              Preview e Teste
            </h3>
            <div style={{ display: 'flex', gap: '12px', flexWrap: 'wrap', marginBottom: '20px' }}>
              <button type="button" style={btnPrimary} onClick={previewSequencia}>
                Preview Sequência
              </button>
              <button type="button" style={{ ...btnSuccess, padding: '10px 24px', fontSize: '14px' }}
                onClick={() => setShowTestForm(!showTestForm)}>
                Testar Execução
              </button>
            </div>

            {/* Test form */}
            {showTestForm && (
              <div style={{
                backgroundColor: '#fafafa', border: '1px solid #e0e0e0', borderRadius: '8px',
                padding: '20px', marginBottom: '20px',
              }}>
                <h4 style={{ fontSize: '14px', fontWeight: '600', color: '#333', marginTop: 0, marginBottom: '16px' }}>
                  Testar Execução
                </h4>
                <div className="responsive-grid" style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '16px', marginBottom: '16px' }}>
                  <div style={fieldGroupStyle}>
                    <label style={labelStyle}>Telefone *</label>
                    <input type="text" style={inputStyle} value={testFormData.telefone}
                      onChange={(e) => setTestFormData({ ...testFormData, telefone: e.target.value })}
                      placeholder="5531999999999" />
                  </div>
                  <div style={fieldGroupStyle}>
                    <label style={labelStyle}>ID da Solicitação (opcional)</label>
                    <input type="text" style={inputStyle} value={testFormData.solicitacao_id}
                      onChange={(e) => setTestFormData({ ...testFormData, solicitacao_id: e.target.value })}
                      placeholder="Ex: 123" />
                  </div>
                </div>
                <div style={{ display: 'flex', gap: '12px' }}>
                  <button type="button" style={{ ...btnSuccess, padding: '10px 24px', fontSize: '14px', opacity: loading ? 0.7 : 1 }}
                    onClick={executarTeste} disabled={loading}>
                    {loading ? 'Executando...' : 'Executar'}
                  </button>
                  <button type="button" style={btnSecondary} onClick={() => setShowTestForm(false)}>
                    Cancelar
                  </button>
                </div>
              </div>
            )}

            {/* Preview result - WhatsApp style bubbles */}
            {previewData && (
              <div style={{
                backgroundColor: '#e5ddd5', borderRadius: '8px', padding: '20px',
                backgroundImage: 'url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAAKCAYAAACNMs+9AAAAFklEQVQYV2P8////fwYiAOOoQoqNAgBJqgMR0K2QXAAAAABJRU5ErkJggg==")',
              }}>
                <div style={{ fontSize: '12px', color: '#666', marginBottom: '12px', fontWeight: '500', textAlign: 'center' }}>
                  Preview da Sequência
                </div>
                <div style={{ display: 'flex', flexDirection: 'column', gap: '8px', maxWidth: '400px', marginLeft: 'auto' }}>
                  {(previewData.preview || previewData.mensagens || previewData).map((msg, idx) => (
                    <div key={idx} style={{
                      backgroundColor: '#dcf8c6', borderRadius: '8px', padding: '10px 14px',
                      boxShadow: '0 1px 2px rgba(0,0,0,0.1)', alignSelf: 'flex-end',
                      maxWidth: '85%', position: 'relative',
                    }}>
                      <div style={{ fontSize: '13px', color: '#333', whiteSpace: 'pre-wrap', lineHeight: '1.4' }}
                        dangerouslySetInnerHTML={{ __html: previewTexto(msg.mensagem_texto || msg.texto || '') }} />
                      {msg.tipo_anexo && msg.tipo_anexo !== 'nenhum' && (
                        <div style={{ marginTop: '6px', fontSize: '11px', color: '#999', fontStyle: 'italic' }}>
                          [{msg.tipo_anexo === 'pdf_resultado' ? 'PDF anexado' : msg.tipo_anexo}]
                        </div>
                      )}
                      <div style={{ fontSize: '10px', color: '#999', textAlign: 'right', marginTop: '4px' }}>
                        {new Date().toLocaleTimeString('pt-BR', { hour: '2-digit', minute: '2-digit' })}
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            )}
          </div>
        )}
      </div>
    );
  };

  // ══════════════════════════════════════════════════════════════════════════
  // MAIN RENDER
  // ══════════════════════════════════════════════════════════════════════════

  return (
    <div className="data-page" style={containerStyle}>
      <div style={pageHeaderStyle}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
          <span style={pageIconStyle}>&#128221;</span>
          <div>
            <h1 style={pageTitleStyle}>Mensagens WhatsApp</h1>
            <p style={pageSubtitleStyle}>Modelos de mensagem e sequ&#234;ncias de envio</p>
          </div>
        </div>
      </div>

      {/* Message notification */}
      {message && (
        <div style={messageStyle(message.tipo)}>
          {message.texto}
        </div>
      )}

      {/* Tabs */}
      <div style={tabContainerStyle}>
        <button type="button"
          style={activeTab === 'modelos' ? tabActiveStyle : tabStyle}
          onClick={() => setActiveTab('modelos')}>
          Modelos de Mensagem
        </button>
        <button type="button"
          style={activeTab === 'sequencias' ? tabActiveStyle : tabStyle}
          onClick={() => setActiveTab('sequencias')}>
          Sequências
        </button>
      </div>

      {/* Tab content */}
      {activeTab === 'modelos' && renderModelos()}
      {activeTab === 'sequencias' && renderSequencias()}
    </div>
  );
};

export default WhatsAppMensagens;
